<template>
  <div class="realTimeBusBox" @click="clickAll" v-if="rawData || errorMsg">
    <div class="outSideBox">
      <div class="contentBox">
        <div class="titleBox">
          <img
            src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/realTimeBusIcon.png"
            alt=""
            class="takeTaxiIcon"
          />
          <div class="titleText">实时公交</div>
        </div>
        <!-- 实时公交主页 -->
        <div
          :class="{ isExpire: isExpire }"
          class="type1"
          v-if="type == 'nearbyStation' || type == 'stationDetail'"
        >
          <div class="stationName">{{ rawData.sn }}</div>
          <div class="busList">
            <div
              class="busItem"
              v-for="(value, key) in rawData.lines"
              :key="key"
              @click="clickItem(value)"
            >
              <div class="left">
                <div class="line1">
                  <div class="lineName">{{ value.line.name }}</div>
                  <div class="tag orange" v-if="value.fav == 1">收藏</div>
                  <div class="tag blue" v-else>附近</div>
                </div>
                <div class="line2">
                  <div class="label">开往</div>
                  <div class="station">{{ value.line.endSn }}</div>
                </div>
              </div>
              <div class="right">
                <div class="line1" v-if="value.stnStates[0]">
                  <!-- 图标 -->
                  <div
                    class="symbol"
                    v-if="calcSymbolStatus(value).show"
                    :class="calcSymbolStatus(value).class"
                  ></div>
                  <div class="status" :class="calcLineStatus(value).textClass">
                    {{ calcLineStatus(value).text }}
                  </div>
                </div>
                <div class="line2" :class="calcLineStatus(value).line2Class">
                  {{ calcLineStatus(value).line2Text }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 实时公交 详情页 -->
        <div
          :class="{ isExpire: isExpire }"
          class="type2"
          v-if="type == 'lineDetail'"
        >
          <div class="lineInfo">
            <div class="lineName">{{ rawData.line.name }}</div>
            <div class="stationInfo">
              <span class="station">{{ rawData.line.startSn }}</span>
              <img
                class="right_arrow_black_symbol"
                src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/right_arrow_black_symbol.png"
                alt=""
              />
              <span class="station">{{ rawData.line.endSn }}</span>
            </div>
            <div class="timeInfo">
              <div class="left">首{{ rawData.line.firstTime }}</div>
              <div class="right">
                <span>末{{ rawData.line.lastTime }}</span>
                <div class="separator"></div>
                <span>票价{{ rawData.line.price }}</span>
              </div>
            </div>
          </div>
          <div class="realTimeInfoBox">
            <div class="box1">
              <div class="container">
                <div class="name">
                  {{ rawData.stations[rawData.targetOrder - 1].sn }}
                </div>
                <div class="detailBox">
                  <div
                    class="item"
                    v-for="(value, key) in rawData.busesRe"
                    :key="key"
                  >
                    <div class="line1">
                      <!-- 图标 -->
                      <div
                        class=""
                        :class="formatVehicleInfo(value, 2).class"
                      ></div>
                      <div class="timeBox">
                        <div
                          class="time"
                          :class="formatVehicleInfo(value, 2).textClass"
                        >
                          {{ formatVehicleInfo(value, 2).text }}
                        </div>
                        <div
                          class="label"
                          :class="formatVehicleInfo(value, 2).textClass"
                        >
                          {{ formatVehicleInfo(value, 2).text_des }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="line2"
                      v-if="formatVehicleInfo(value, 2).text_des"
                    >
                      <span>{{ formatVehicleInfo(value, 2).info }}</span>
                      <span>·</span>
                      <span>{{ formatDistance(value.distanceToWaitStn) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 滚动容器 -->
            <div class="scrollBox">
              <!-- 承载容器 -->
              <div class="box_container">
                <div
                  class="stationItem"
                  v-for="(value, key) in drivingList"
                  :key="key"
                >
                  <!-- 线路主体 -->
                  <!-- 先画线路基线 -->
                  <div class="roadDefault"></div>
                  <div class="stationLine">
                    <!-- 组成基线的元素块 -->
                    <div
                      v-for="(value2, key2) in value.roads"
                      :key="key2"
                      class="stationLineBlock"
                      :class="formatColorName(value2.tvl)"
                      :style="{ width: `${value2.tpc * 100}%` }"
                    ></div>
                  </div>
                  <!-- 画图标 -->
                  <div class="stationLogo">
                    <img
                      class="icon_map_point"
                      v-if="key == 0 || key == drivingList.length - 1"
                      src="https://h5liuzhou.oss-cn-shanghai.aliyuncs.com/realTimeBus/icon_map_point.png"
                      alt=""
                    />
                    <img
                      class="icon_line_arrow"
                      v-else
                      src="https://h5liuzhou.oss-cn-shanghai.aliyuncs.com/realTimeBus/icon_line_arrow.png"
                      alt=""
                    />
                    <!--       车行轨迹上方的小车icon       -->
                    <img
                      v-if="showBusIcon(key)"
                      class="busIcon"
                      :class="
                        showBusIcon(key).state == 1 ? 'marginNow' : 'marginWait'
                      "
                      src="https://h5liuzhou.oss-cn-shanghai.aliyuncs.com/realTimeBus/icon_bus.png"
                    />
                  </div>
                  <!-- 画最近 -->
                  <div
                    class="stationNear"
                    v-if="rawData.targetOrder == value.stations.order"
                  >
                    最近
                  </div>
                  <!-- 然后加上文字 -->
                  <div style="display: flex">
                    <div
                      class="stationText"
                      :class="formatStationName(value.stations).class"
                    >
                      {{ value.stations.sn }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 实时公交 时刻表 -->
        <div
          :class="{ isExpire: isExpire }"
          class="type3"
          v-if="type == 'lineSchedule'"
        >
          <div class="outBox" v-for="(value, key) in rawData" :key="key">
            <div class="lineInfo">
              <div class="lineName">{{ value.line.name }}</div>
              <div class="stationInfo">
                <span class="station">{{ value.line.startSn }}</span>
                <img
                  class="right_arrow_black_symbol"
                  src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/right_arrow_black_symbol.png"
                  alt=""
                />
                <span class="station">{{ value.line.endSn }}</span>
              </div>
              <div class="timeInfo">
                <div class="left">首{{ value.line.firstTime }}</div>
                <div class="right">
                  <span>末{{ value.line.lastTime }}</span>
                  <div class="separator"></div>
                  <span>票价{{ value.line.price }}</span>
                </div>
              </div>
            </div>
            <div class="tableBox">
              <div class="tableBoxContent">
                <div
                  class="timeItem"
                  v-for="(value2, key2) in value.times"
                  :key="key2"
                >
                  {{ value2 }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 错误信息 -->
        <div
          class="errorMsgBox"
          v-if="errorMsg != ''"
          :class="{ isExpire: isExpire }"
          @click="clickMoreBtn"
        >
          {{ errorMsg }}
        </div>
        <div
          class="bottomBar"
          :class="{ isExpire: isExpire }"
          v-if="
            errorMsg != '' ||
            type == 'lineDetail' ||
            type == 'stationDetail' ||
            type == 'nearbyStation'
          "
        >
          <div class="moreBox" @click="clickMoreBtn">
            <div class="text">查看更多</div>
            <img
              class="right_arrow_gray"
              src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/right_arrow_gray.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const config = {
  dxlc: {
    test: "https://lzgj.test.brightcns.cn/onlineBus/",
    prod: "https://h5-lzgj.brightcns.com/onlineBus/",
  },
  cxnt: {
    test: "https://h5-ntgj.test.brightcns.cn/onlineBus/",
    prod: "https://h5-maas.speedits.com/onlineBus/",
  },
};
const env = process.env.VUE_APP_ENV;
export default {
  data: function () {
    return {
      isExpire: false,
      type: null,
      drivingList: [],
      rawData: null,
      timer: null,
      errorMsg: "",
    };
  },
  props: ["businessContent"],
  methods: {
    // 点击整个卡片
    clickAll: function () {
      if (this.isExpire) {
        this.$toast("已失效");
        setTimeout(() => {
          this.jumpToH5(-1);
        }, 1000);
      } else {
        if (this.businessContent.type == "lineSchedule") {
          this.jumpToH5(3);
        }
      }
    },
    // 当type为nearbyStation或stationDetail时 点击某一项 跳到线路详情
    clickItem: function (value) {
      if (this.isExpire) {
        return;
      }
      this.jumpToH5(1, value.line.name);
    },
    // 点击查看更多
    clickMoreBtn: function () {
      if (this.isExpire) {
        return;
      }
      // 如果有错误信息 跳到实时公交首页
      if (this.errorMsg != "") {
        this.jumpToH5(-1);
        return;
      }
      // 跳站点详情
      if (this.type == "nearbyStation" || this.type == "stationDetail") {
        this.jumpToH5(2);
      }
      // 跳线路详情
      if (this.type == "lineDetail") {
        this.jumpToH5(1, this.rawData.line.name);
      }
    },
    // 跳到H5   type  -1=>跳到实时公交首页  1=>跳到线路详情  2=>跳到站点详情  3=>跳到发车时刻表
    jumpToH5: function (type, lineName) {
      let url = config[this.businessContent.channel][env];
      console.log(type);
      switch (type) {
        case -1:
          url =
            url +
            `#/AiPage?sessionId=${localStorage.getItem(
              "sessionId"
            )}&path=IndexPage`;
          break;
        case 1:
          url =
            url +
            `#/AiPage?sessionId=${localStorage.getItem(
              "sessionId"
            )}&path=LineDetailPage&lineName=${lineName}`;
          break;
        case 2:
          url =
            url +
            `#/AiPage?sessionId=${localStorage.getItem(
              "sessionId"
            )}&path=StationDetailPage&stationName=${this.rawData.sn}`;
          break;
        case 3:
          url =
            url +
            `#/AiPage?sessionId=${localStorage.getItem(
              "sessionId"
            )}&path=TimetablePage&lineName=${this.rawData[0].line.name}`;
          break;
      }
      console.log(url);
      window.location.href = url;
    },
    // 检测卡片是否过期
    checkIsExpire: function (businessContent) {
      let expireTime = new Date(
        businessContent.expireTime.replace(/-/g, "/")
      ).getTime();
      let nowTime = new Date().getTime();
      if (nowTime > expireTime) {
        this.isExpire = true;
      } else {
        console.log("卡片过期时间", expireTime - nowTime);
        this.timer = setTimeout(() => {
          this.isExpire = true;
          clearTimeout(this.timer);
          this.timer = null;
        }, expireTime - nowTime);
      }
    },
    // 传入颜色等级，返回对应的class名
    formatColorName: function (tvl) {
      switch (tvl) {
        case "1":
          return "tvl1";
        case "2":
          return "tvl2";
        case "3":
          return "tvl3";
        case "4":
          return "tvl4";
      }
    },
    formatDistance: function (distance) {
      if (distance > 999) {
        return (distance / 1000).toFixed(2).slice(0, -1) + "公里";
      }
      return distance + "米";
    },
    //站点名字的样式
    formatStationName: function (station) {
      if (station.order > this.rawData.targetOrder) {
        return { class: "blackBold" };
      }
      if (station.order == this.rawData.targetOrder) {
        return { class: "blueBold" };
      }
      if (station.order < this.rawData.targetOrder) {
        return { class: "gray1" };
      }
      return { class: "blue" };
    },
    // 计算线路的状态
    calcLineStatus: function (value) {
      let obj = {
        text: "",
        textClass: "",
        line2Text: "",
        line2Class: "",
        // 1 蓝色  2 橙色 3 灰色
        type: -1,
      };
      if (value.state != 0) {
        obj.type = 3;
        switch (value.state) {
          case -1:
            obj.text = "等待发车";
            obj.textClass = "grayText";
            obj.line2Text = "";
            obj.line2Class = "";
            break;
          case -2:
            obj.text = "暂时失联";
            obj.textClass = "grayText";
            obj.line2Text = "正在紧急处理";
            obj.line2Class = "grayText";
            break;
          case -3:
            obj.text = "末班已过";
            obj.textClass = "grayText";
            obj.line2Text = `首${value.line.firstTime} 末${value.line.lastTime}`;
            obj.line2Class = "grayText";
            break;
          case -4:
            obj.text = "首班未发";
            obj.textClass = "grayText";
            obj.line2Text = `首${value.line.firstTime} 末${value.line.lastTime}`;
            obj.line2Class = "grayText";
            break;
          case -5:
            obj.text = "暂未开通";
            obj.textClass = "grayText";
            obj.line2Text = "";
            obj.line2Class = "";
            break;
        }
      } else if (value.state == 0) {
        if (value.stnStates[0]) {
          // 橙色
          if (value.stnStates[0].value == -1 || value.stnStates[0].value == 0) {
            obj.type = 2;
            if (value.stnStates[0].value == -1) {
              obj.text = "已到站";
              obj.textClass = "orangeText";
            }
            if (value.stnStates[0].value == 0) {
              obj.text = "即将到站";
              obj.textClass = "orangeText";
            }
          } else if (value.stnStates[0].value > 0) {
            obj.type = 1;
            obj.textClass = "blueText";
            let text = "";
            text =
              text + Math.floor(value.stnStates[0].travelTime / 60) + "分钟";
            text = text + "·";
            text = text + value.stnStates[0].value + "站";
            text = text + "·";
            text = text + this.formatDistance(value.stnStates[0].distance);
            obj.text = text;
          } else if (value.stnStates[0].value == -2) {
            obj.type = 3;
            obj.textClass = "grayText";
            obj.text = "未知 正常";
          }
          if (value.stnStates[1]) {
            obj.line2Text = `下辆 ${Math.floor(
              value.stnStates[1].travelTime / 60
            )}分钟 · ${value.stnStates[1].value}站`;
            obj.line2Class = "grayText";
          }
        }
      }
      return obj;
    },
    // 计算图标是否展示
    calcSymbolStatus: function (value) {
      let obj = {
        show: false,
      };
      if (value.state != 0) {
        return obj;
      }
      if (value.stnStates[0]) {
        if (value.stnStates[0].value == -1 || value.stnStates[0].value == 0) {
          // 展示黄色图标
          obj.class = "orangeIcon orangeArrived";
          obj.show = true;
          return obj;
        } else if (value.stnStates[0].value > 0) {
          // 展示蓝色图标
          obj.class = "blueIcon blueArrived";
          obj.show = true;
          return obj;
        }
      } else {
        return obj;
      }
    },
    showBusIcon(key) {
      let bus = this.rawData.buses.find((item) => item.order == key);
      if (bus) {
        return bus;
      }
    },
    //公交时间信息的附带描述 分为两种情况，车辆气泡展示1/线路信息展示2
    formatVehicleInfo: function (item, type) {
      if (type == 1 && this.rawData.targetOrder < item.order) {
        return {
          text: "已过站",
          text_des: "",
          color: "gray",
          textClass: "gray",
          class: "orangeIcon",
          info: "",
          popText: "已过站",
        };
      }

      if (this.rawData.targetOrder - item.order == 0) {
        if (item.state == 0) {
          return {
            text:
              Math.floor(item.travels[0].travelTime / 60) == 0
                ? item.travels[0].travelTime
                : Math.floor(item.travels[0].travelTime / 60),
            text_des:
              Math.floor(item.travels[0].travelTime / 60) == 0 ? "秒" : "分钟",
            color: "orange",
            textClass: "orangeBigFont",
            class: "orangeIcon",
            info: "即将到站",
            popText: "即将到站",
          };
        }
        return {
          text: "已到站",
          text_des: "",
          color: "orange",
          textClass: "orangeFont",
          class: "orangeIcon",
          info: "",
          popText: "已到站",
        };
      }

      return {
        text:
          Math.floor(item.travels[0].travelTime / 60) == 0
            ? item.travels[0].travelTime
            : Math.floor(item.travels[0].travelTime / 60),
        text_des:
          Math.floor(item.travels[0].travelTime / 60) == 0 ? "秒" : "分钟",
        color: "blue",
        textClass: "blueFont",
        class: "blueIcon",
        info: this.rawData.targetOrder - item.order + "站",
        popText: this.rawData.targetOrder - item.order + "站",
      };
    },
  },
  mounted: function () {
    if (this.businessContent.bizCode == "SUCCESS") {
      this.type = this.businessContent.type;
      this.rawData = JSON.parse(this.businessContent.bizData);
      if (this.type == "lineDetail") {
        this.rawData.busesRe = [...this.rawData.buses].reverse().splice(0, 2);
      }
      console.log(this.rawData);
      let drivingList = [];
      for (let i in this.rawData.stations) {
        let obj = {
          stations: this.rawData.stations[i],
          roads: this.rawData.roads[i] ? this.rawData.roads[i] : [],
        };
        drivingList.push(obj);
      }
      this.drivingList = drivingList;
    } else {
      this.errorMsg = this.businessContent.bizMsg;
    }
    this.checkIsExpire(this.businessContent);
  },
  destroyed: function () {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./realTimeBusBox.scss";
</style>
